import type { ContextuneSnapshot } from "../types.js";

export function toJson(snap: ContextuneSnapshot): string {
  return JSON.stringify(snap);
}
